/**
 * Gets the Olympic year from URL parameters
 *
 * Priority:
 * 1. If testfile param exists → always returns 2022 (test files are for Beijing Olympics)
 * 2. If date param exists → extracts year from date
 * 3. Otherwise → returns current year
 *
 * @returns The Olympic year (2022, 2026, etc.)
 *
 * Examples:
 * - ?testfile=test1 → 2022
 * - ?date=2022-02-05 → 2022
 * - ?date=2026-02-10 → 2026
 * - no params → current year
 */
export function getOlympicYearFromURL(): number {
  const params = new URLSearchParams(window.location.search);
  const testFile = params.get('testfile');

  // Test files are always for 2022
  if (testFile) {
    return 2022;
  }

  const dateParam = params.get('date');
  if (dateParam) {
    try {
      const [year] = dateParam.split('-').map(Number);
      if (year) {
        return year;
      }
    } catch {
      // Fall through to default
    }
  }

  return new Date().getFullYear();
}
